const network = {
  messagePrefix: "\x19Dogecoin Signed Message:\n",
  bip32: {
    public: 0x02facafd,
    private: 0x02fac398,
  },
  pubKeyHash: 0x1e,
  scriptHash: 0x16,
  wif: 0x9e,
};


export default network;